import {RecentError} from '../types/RecentError';
import {aiAssistantContextStore} from './aiAssistantContextStore';
import {appendRecentError} from './appendRecentError';

const MAX_RECENT_ERRORS = 10;
/** A thrown message is arbitrary-length text, and the buffer rides along with every chat turn. */
const MAX_RECENT_ERROR_MESSAGE_CHARACTERS = 1024;

/**
 * Appends an error to the store (no re-render), stamping the time and capping the buffer. Callable
 * from non-React sources (RTK middleware, window listeners) — why the store is a module singleton.
 */
export const recordAiAssistantError = (error: Omit<RecentError, 'time'>) => {
  const {recentErrors} = aiAssistantContextStore.getContext();
  const entry: RecentError = {
    ...error,
    message: error.message.slice(0, MAX_RECENT_ERROR_MESSAGE_CHARACTERS),
    time: new Date().toISOString(),
  };
  aiAssistantContextStore.patchContext({
    recentErrors: appendRecentError(recentErrors, entry, MAX_RECENT_ERRORS),
  });
};
